export default "__VITE_ASSET__BKamihjp__"